export const glassmorphicStyle: React.CSSProperties = {
  background: "rgba(255, 255, 255, 0.45)",
  backdropFilter: "blur(8px)",
  border: "1px solid rgba(255,255,255,0.4)",
  boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
};